module.exports = "/assets/767a9410372bcf1ebb58a4c932162515.png";